<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="file_015"><img alt="Image" src="images/f0010-01.jpg"/></a></p><a id="file_015">
<p class="caption">This rare image shows Grumman’s first facility in Baldwin, New York. Rumor has it that Grumman Aircraft Engineering didn’t really have a sign most of the time. It was hastily assembled by the shop men especially for the photo. <em>Grumman History Center</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_015.vue?31c5f5d0